module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ApplyAfterSaleView.js"));
	}, "ApplyAfterSaleView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ApplyAfterSaleView!./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleView.js
// module id = 1545
// module chunks = 418